import { BODY_LG_LG_MEDIUM_STYLES } from '@constants/text.ts';
import styled from 'styled-components';

export const Title = styled.div`
    ${BODY_LG_LG_MEDIUM_STYLES};
    color: var(--colors-text-headings, #3e445c);
    display: flex;
    align-items: center;
    gap: 8px;
`;
